import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const gameVuex = createNamespacedHelpers("game");
const userVuex = createNamespacedHelpers("user");
export default {
  name: "airdrop",
  computed: {
    ...userVuex.mapState(["didInfo", "userInfo"]),
    ...gameVuex.mapState(["gameProgress"])
  },
  methods: {
    onSkip(path) {
      this.hapticFeedback();
      this.$router.push(path);
    }
  },
  mounted() {
    this.setWowAnim();
  }
};